import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import QualEventsContainer from './qual-events.container.js';

class QualEventsComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    static getRequiredRefs() {
        return ['cardsRootContainer'];
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.refs.cardsRootContainer);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <QualEventsContainer options={this.options} />
            </Provider>,
            this.refs.cardsRootContainer
        );
    }
}

export default QualEventsComponent;
